<script setup>
import {Link} from '@inertiajs/vue3';
import axios from "axios";
import { inject } from 'vue';

const props = defineProps({
    id: Number,
    title: String,
    short_description: String,
    category_name: String,
    category_slug: String,
    first_name: String,
    last_name: String,
    created_at: String,
    slug: String,
    image: String,
    body: String,
    format: String,
    isActive: false,
    link_url: String,
});

const setAudioSource = inject('setAudioSource');

function playAudio(id, title, image, link_url) {
    setAudioSource(id, title, image, link_url);
    onShowDialog(id);
}

async function onShowDialog() {
    await axios.get(route('update.count'),{
        params: {
            id: props.id,
        },
    });
}



</script>
<template>
    
    <v-col cols="12" md="4" sm="6" lg="4">
        
        <v-card class="audio-card" >
            <v-card variant="tonal" class="audio-card" @click="playAudio(id, title, image, link_url)">
                <div class="card-img-cover w-100 h-100 position-relative">
                    <img :src="getImage(image)" class="card-img-top w-100 h-100" :alt="title">

                    <div class="d-flex align-items-center justify-content-lg-start button-play-title w-100 position-absolute pl-2">
                        <img src="/assets/img/logo-youtube.png" style="left: 5px;color: #00000069 !important; width: 50px; height: 50px; object-fit: cover; margin-right: 10px;">
                        <h6 class="text-white bold mb-0" style="color: white !important;">{{ title }}</h6>
                    </div>

                </div>
            </v-card>
        </v-card>
    </v-col>
</template>

<style scoped>

.button-play-title{
    text-align: left;
    bottom: 0px;
    height: 70px;
    left: 0px;
    background-color: #0a0a0a70;
}

.button-play-title {
    
    display: flex;
    align-items: center;
    width: 100%;
}

.play-button img {
    width: 60px;
    height: 60px;
    object-fit: cover;
}

.title-video {
    background-color: #d3d3d3; /* Example color for testing */
    padding: 10px;
    border-radius: 5px;
}

@media (max-width: 768px) {
    .card-audio {
        height: 250px !important;
    }
    .card-audio-text {
        padding-top: 6px !important;
        padding-bottom: 6px !important;
    }
}

</style>
